import { useEffect, useState } from "react";
import Config from "../pages/Config";
import {useSearchParams} from "react-router-dom";

function useFetchProducts() {
  const [Data, setData] = useState(null);
  const [Loading, setLoading] = useState(false);
  const [RefreshIndex, setRefreshIndex] = useState(0);
  const [searchParams] = useSearchParams();
  const [sortby, setSortby] = useState("recent");

  useEffect(()=>{
    let ref = localStorage.getItem("refid") || "";
    let agent = localStorage.getItem("agentid") || "";
    if(searchParams.get("agent")) {
      agent = searchParams.get("agent");
    }
    if(searchParams.get("ref")) {
      ref = searchParams.get("ref");
    }
    let isActive = true;
    const Fetch = async () =>{
      try{
        setLoading(true);
        const res = await fetch(Config.NodePath+"/api/products?fetchfrom=home&agent="+agent+"&ref="+ref+"&sortby="+sortby);
        if(!isActive) return;
        if(res.ok) {
          const data = await res.json();
          setData(data);
        }

      }
      catch(err) {
        console.log(err);
      }
      finally{
        setLoading(false);
      }
    }
  Fetch();
  return () => {
    isActive = false;
  };
  }, [RefreshIndex, searchParams, sortby]);
  return {Data, Loading, refresh:()=>setRefreshIndex(prev=>prev+1), Sort:(x)=>setSortby(x)};
}

export default useFetchProducts;